import { getEveryoneLayout } from '../layouts/everyone';
import { EnterArenas } from '../components/arena/EnterArenas';

const Home = () => {
  return <EnterArenas />;
};

Home.getLayout = getEveryoneLayout;
export default Home;
